import TAGGED from "../modules/tagged_content"
import GET_ARTICLES from "../plugins/getArticles"
import LAZYDISP from "../plugins/lazydisp"

const [ w, d, l, content ] = [ window, document, location, 'order' ]

const init = ID => {
  let widepageID = [ 4, 5, 6, 7, 8, 9, 10, 11 ]
  if( widepageID.findIndex( v => v == ID ) != -1 ){
    d.body.classList.add('is-wide-layout')
    d.querySelector('.mainImg').classList.add('hide')
    d.querySelector('.breadcrumbs').classList.add('hide')
  }
  if( w.load['nav-msmart'] ){
    w.load['nav-msmart'].then( () => {
      $('.nav-msmart[data-plugin="currentMenu"]').currentMenu({mode:0})
    })
  }

	//design-casa：アコーディオンスタイル
	if( w.load['service-designcasa'] ){
		w.load['service-designcasa'].then( () => {
			$('.p-casa-process__item h4.accordion-btn').on('click', function(){
				$(this).next('.p-casa-process__item .accordion-body').slideToggle()
				$(this).toggleClass('open-ac')
			})
		})
  }
  

  // m-smartブロック
  if( w.load['block-msmart'] ){

    $.when( w.load['block-msmart'] ).then( () => {
      let makeItem = item => {
        return $(`
          <a href="${item.href}" class="msmart-item">
            <figure class="msmart-item__img">
              <div class="msmart-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="100%" height="100%" loading="lazy"></div>
            </figure>
            <div class="msmart-item__body">
              <h4 class="subject">${item.title}</h4>
            </div>
          </a>
        `)[0]
      }
      GET_ARTICLES('.block-msmart__list[data-plugin="getArticles"]', { makeItem })
    })
  }

  // アフターケアブロック
  if( w.load['block-aftercare'] ){

    $.when( w.load['block-aftercare'] ).then( () => {
      let makeItem = item => {
        return $(`
          <a href="${item.href}" class="aftercare-item">
            <figure class="aftercare-item__img">
              <div class="aftercare-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="100%" height="100%" loading="lazy"></div>
            </figure>
            <div class="aftercare-item__body">
              <h4 class="subject">${item.title}</h4>
            </div>
          </a>
        `)[0]
      }
      GET_ARTICLES('.block-aftercare__list[data-plugin="getArticles"]', { makeItem })
    })
  }
}

export default function ORDER () {
  TAGGED({
    perpage: 20,
    related: false,
    taglist_disp_list: 'head', // head / foot / both
    taglist_disp_detail: false, // head / foot / both
    taglist_minimumTagAmount : 12, // タグの最低表示数
    taglist_hideUselessTags : 4, // 最低使用回数
    itemTemplate:`
        <div id="main" class="column-3-4">
          <transition-group class="${content}-list" tag="div" name="fade" mode="out-in" :class="[ 'is-paged-' + paged ]">
            <a class="${content}-item" :href="article.href" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]" data-lazydisp="bottom">
              <figure class="${content}-item__img">
                <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'">
                  <img :src="article.thumb" width="200" loading="lazy">
                </div>
              </figure>
              <div class="${content}-item__body">
                <div class="${content}-item__body-inner">
                  <div class="tags" v-if="article.keywords != null">
                    <span class="tag" v-for="tag in article.keywords">{{tag}}</span>
                  </div>
                  <span class="subject">
                    {{ article.title }}
                  </span>
                  <p class="desc">{{ article.desc }}</p>
                </div>
              </div>
            </a>
          </transition-group>
          <pagination
            v-if="totalPage > 1"
            :paged="paged"
            :total-page="totalPage"
            :total-item="totalItem"
            :item-count="pagedArticles.length"
            :prevText="'Prev'"
            :nextText="'Next'"
            @change="pageChange"
          />
        </div>
      `,
    callback () {
      LAZYDISP('[data-lazydisp]')
    }
  })
  $(() => init( w.query_string('article') ) )
}